import React from 'react'
import { useNavigate } from 'react-router-dom'
import GardenMasterCard from './GardenMasterCard'
import { useAuthState } from '../../../../../Helper/Context';


export default function GardenMasterCardManage(props) {

    const { Countdata, setAssetID, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName } = props
    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user

    const handleAsset = (title) => {
        if (title === "Garden") {
            setAssetID(1)
            MasterNavigate("Garden Master")
        } else if (title === "Road Divider") {
            setAssetID(2)
            MasterNavigate("Road Divider")
        } else if (title === "Open Space") {
            setAssetID(3)
            MasterNavigate("Open Space")
        } else if (title === "Tree Belt's") {
            setAssetID(4)
            MasterNavigate("Tree Belt’s")
        } else if (title === "Chowk's") {
            setAssetID(5)
            MasterNavigate("Chowk’s")
        }
    }

    const MasterNavigate = (name, screenFlag) => {
        if (RoleID == '1' || RoleID == '6' || RoleID == '9' || RoleID == '51') {
            if (name === "Garden Master") {
                navigate(`/gardenmaster?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&AssetID=1`)
            } else if (name === "Road Divider") {
                navigate(`/roaddivider?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&AssetID=2`)
            } else if (name === "Open Space") {
                navigate(`/openspace?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&AssetID=3`)
            } else if (name === "Tree Belt’s") {
                navigate(`/treebelt?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&AssetID=4`)
            } else if (name === "Chowk’s") {
                navigate(`/chowks?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&AssetID=5`)
            }
        }
    }
    const navigate = useNavigate()

    return (
        <>
            {/* <div className="row">
            </div> */}

            <div className='row m-1 p-0  ' >

                {/* <div className='col-12 col-lg-2 col-md-6 text-center mast_card_width'> */}

                {/* <h5 className=" py-2 mb-0 border5 mb-1">Master</h5> */}
                <div className='row px-2 m-0 pt-1'>
                    <div class="mb-0 col-sm-6 mastercard ">
                        <GardenMasterCard
                            title="Garden"
                            cardName='py-2 green cursor'
                            masterCard='card-body mastercardborderpink'
                            count={Countdata.GardenTotalCount ? Countdata.GardenTotalCount : '0'}
                            navLink='/gardenmaster'
                            imgPath="./assets/img/pine-tree.png"
                            BgColor='purple'
                            MasterNavigate={MasterNavigate}
                            handleAsset={handleAsset}
                            M_AssetTypeID='1'
                        />
                    </div>
                    <div class="mb-0 col-sm-6 mastercard">
                        <GardenMasterCard
                            title="Road Divider"
                            cardName='py-2 blue cursor'
                            masterCard='card-body mastercardborderblue'
                            count={Countdata.RoadDividerTotalCount ? Countdata.RoadDividerTotalCount : '0'}
                            navLink='/roaddivider'
                            imgPath="./assets/img/diversion.png"
                            BgColor='skyblue'
                            MasterNavigate={MasterNavigate}
                            handleAsset={handleAsset}
                            M_AssetTypeID='2'
                        />
                    </div>

                    <div class="mb-0 col-sm-6 mastercard">
                        <GardenMasterCard
                            title="Open Space"
                            cardName='py-2 green cursor'
                            masterCard='card-body mastercardborderpink'
                            count={Countdata.OpenSpaceTotalCount ? Countdata.OpenSpaceTotalCount : '0'}
                            navLink='/openspace'
                            imgPath="./assets/img/tree.png"
                            BgColor='purple'
                            MasterNavigate={MasterNavigate}
                            handleAsset={handleAsset}
                            M_AssetTypeID='3'
                        />
                    </div>

                    <div class="mb-0 col-sm-6 mastercard">
                        <GardenMasterCard
                            title="Tree Belt's"
                            cardName='py-2 blue cursor'
                            masterCard='card-body mastercardborderblue'
                            count={Countdata.TreeBeltTotalCount ? Countdata.TreeBeltTotalCount : '0'}
                            navLink='/treebelt'
                            imgPath="./assets/img/chainsaw.png"
                            BgColor='skyblue'
                            MasterNavigate={MasterNavigate}
                            handleAsset={handleAsset}
                            M_AssetTypeID='4'
                        />
                    </div>
                    <div class="mb-0 col-sm-6 mastercard">
                        <GardenMasterCard
                            title="Chowk's"
                            cardName='py-2 green cursor'
                            masterCard='card-body mastercardborderpink'
                            count={Countdata.ChowksTotalCount ? Countdata.ChowksTotalCount : '0'}
                            navLink='/chowks'
                            imgPath="./assets/img/intersection.png"
                            BgColor='purple'
                            MasterNavigate={MasterNavigate}
                            handleAsset={handleAsset}
                            M_AssetTypeID='5'
                        />
                    </div>
                </div>

            </div>


        </>



    )

}

